import { Divider } from '@/components/base/divider'
import { NavLink } from '@/components/layout/navlink'
import { Outlet } from 'react-router'

export const Layout = () => {
  return (
    <>
      <div className="flex flex-col gap-4">
        <div className="flex flex-row gap-8 items-center">
          {/* <NavLink to="/website">Pages</NavLink> */}
          <NavLink to="/portfolio">Portfolio</NavLink>
        </div>
        <Divider />
        <Outlet />
      </div>
    </>
  )
}
